import useOfferingManagementContextView from './UseOfferingManagementContextView';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';

import { ERROR_MSG, LOADING_MSG } from '@usas/ui-web/utils/Constants';

const HqOfferingManagementContextLoadingModal = ({ isLoading, loadingMessage = LOADING_MSG,
  isError, errorMessage = ERROR_MSG }) => {
  const {
    onReloadClicked
  } = useOfferingManagementContextView();

  if (isError === true) {
    return (
      <PopUpModal
        widthPct={90}
        maxWidth={720}
        title={'Offering Management Error'}
        displayPopUp={true}
        onModalCanceled={onReloadClicked}>
        <div className="row">
          <div className="col-xs-12">
            <p>{errorMessage}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="button" onClick={onReloadClicked}>Reload HQ Offering Management</PrimaryButton>
          </div>
        </div>
      </PopUpModal>
    );
  } else {
    return (
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={loadingMessage}
        displayPopUp={isLoading === true} />
    );
  }
};

export default HqOfferingManagementContextLoadingModal;